import { useQuery, useQueryClient } from "react-query";
import { getToken } from "../components/helpers/tokenAquirer";
import { useMsal, useAccount } from "@azure/msal-react";

export function useTokenQuery() {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const queryClient = useQueryClient();

  return useQuery(
    "token",
    () => {
      // Use getToken to fetch the latest token
      return getToken(instance, account, inProgress);
    },
    {
      enabled: !!account && inProgress === "none", // Only trigger query when account is available and auth is not in progress
      onError: () => {
        queryClient.invalidateQueries("token"); // Manually invalidate the token query on error
      },
    },
  );
}
